import SectionCard from '@Guidelines/Component/SectionCard';
import type SubjectTypeDefinitionFormData from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import WordingInput from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/Sections/Wording/WordingInput';
import type * as React from 'react';
import { Grid, GridItem } from '@verclam/grid-system';

type Props = {
	readonly formData: SubjectTypeDefinitionFormData;
	readonly onChange: (
		update: (formData: SubjectTypeDefinitionFormData) => SubjectTypeDefinitionFormData,
	) => void;
	readonly isReadOnly: boolean;
};

/** The words the application uses for this type: each one is a complete phrase, displayed as typed. */
const WordingSection: React.FC<Props> = ({ formData, onChange, isReadOnly }) => {
	return (
		<SectionCard
			title="Nom et vocabulaire"
			description="Chaque libellé est une phrase complète : il s'affiche tel quel."
		>
			<Grid columns={12} columnGap={1} rowGap={1}>
				<GridItem columnSize={{ xs: 12, md: 6 }}>
					<WordingInput
						formData={formData}
						onChange={onChange}
						part="singular"
						label="Nom au singulier"
						required
						disabled={isReadOnly}
					/>
				</GridItem>
				<GridItem columnSize={{ xs: 12, md: 6 }}>
					<WordingInput
						formData={formData}
						onChange={onChange}
						part="plural"
						label="Nom au pluriel"
						required
						disabled={isReadOnly}
					/>
				</GridItem>
				<GridItem>
					<WordingInput
						formData={formData}
						onChange={onChange}
						part="createAction"
						label="Bouton de création"
						required
						disabled={isReadOnly}
					/>
				</GridItem>
				<GridItem>
					<WordingInput
						formData={formData}
						onChange={onChange}
						part="emptyList"
						label="Liste vide"
						required
						disabled={isReadOnly}
					/>
				</GridItem>
				<GridItem>
					<WordingInput
						formData={formData}
						onChange={onChange}
						part="sheetTitle"
						label="Titre de la fiche"
						subLabel="Requis dès que la fiche compte un champ."
						disabled={isReadOnly}
					/>
				</GridItem>
				<GridItem>
					<WordingInput
						formData={formData}
						onChange={onChange}
						part="titleLabel"
						label="Libellé du champ « Intitulé »"
						subLabel="Exemple : Nom de l'instance."
						required
						disabled={isReadOnly}
					/>
				</GridItem>
			</Grid>
		</SectionCard>
	);
};

export default WordingSection;
